// CSS-driven marquee ticker for drafting-style keyword strip.
export function Marquee({ items, className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div className={`overflow-hidden border-y border-border bg-secondary/30 py-4 ${className}`} data-testid="marquee">
      <div className="marquee-track whitespace-nowrap">
        {doubled.map((it, i) => (
          <span key={i} className="font-mono-tech text-xs sm:text-sm tracking-widest uppercase text-muted-foreground mx-6 inline-flex items-center gap-6">
            {it}
            <span className="text-primary">/</span>
          </span>
        ))}
      </div>
    </div>
  );
}
